$(function () {


    //------------------------------------------------------------
    // For detecting mobile devices
    //------------------------------------------------------------

    var isMobile = (navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i)) ? true : false;

    var isIos = (navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)) ? true : false;

    if (isMobile) {
        $(document.body).addClass('isMobile');
    }

    if (isIos) {
        $(document.body).addClass('isIos');
    }

    if (!isMobile) {
        $('[data-toggle="tooltip"]').tooltip({
            trigger: 'hover',
            placement: 'bottom',
            html: true
        });
    }

    //------------------------------------------------------------


    //------------------------------------------------------------
    // For making indent in section on Header height val
    //------------------------------------------------------------

    var $header = $('.header');
    var headerHeight = $header.innerHeight();

    var $navAnchor = $('.nav-anchor');
    // var $heroProList = $('.hero-pro-list');
    // var $heroTools = $('.hero-tools');
    // var heroToolsHeight = 420;

    function setElStyle(el, prop, val) {
        el.css(prop, val);
    }

    setElStyle($navAnchor, 'marginTop', headerHeight);
    // setElStyle($heroProList, 'paddingTop', headerHeight);
    // setElStyle($heroTools, 'paddingTop', headerHeight);
    // setElStyle($heroTools, 'min-height', heroToolsHeight - headerHeight);

    $(window).resize(function (e) {
        var headerHeight = $header.innerHeight();

        setElStyle($navAnchor, 'marginTop', headerHeight);
        // setElStyle($heroProList, 'paddingTop', headerHeight);
        // setElStyle($heroTools, 'paddingTop', headerHeight);
        // setElStyle($heroTools, 'min-height', heroToolsHeight - headerHeight);
    });


    //------------------------------------------------------------

    toggleMobileMenu();

    function toggleMobileMenu() {
        $('.menu-item.dropdown > a[href="#"]').on('click', function (e) {
            e.preventDefault();
            if ($(window).width() < 1200) {
                $(this).siblings('.nav-item.dropdown').slideToggle();
            }
        });
    }


});
